import { Grid, Typography, useTheme } from "@mui/material";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import React from "react";

interface OwnProps {}

type Props = OwnProps;

const EmptyNotifications: React.FC<Props> = (props) => {
    const theme = useTheme();

    return (
        <>
            <Grid
                item
                xs={12}
                container
                justifyContent={"center"}
                sx={{ marginTop: theme.spacing(7) }}
            >
                <NotificationsActiveRoundedIcon
                    sx={{
                        fontSize: "40px",
                        color: theme.palette.gray[300],
                    }}
                />
            </Grid>
            <Grid
                item
                xs={12}
                sx={{
                    marginTop: theme.spacing(2),
                    paddingX: theme.spacing(4),
                    textAlign: "center",
                    // AcxDrawer sets nowrap on its content
                    whiteSpace: "normal",
                }}
            >
                <Typography
                    variant={"h2"}
                    sx={{ color: theme.palette.gray[700] }}
                >
                    You&apos;re all caught up!
                </Typography>
                <Typography
                    variant={"body2"}
                    sx={{
                        color: theme.palette.gray[600],
                        marginTop: theme.spacing(1),
                    }}
                >
                    No new notifications right now. Check back later for
                    updates.
                </Typography>
            </Grid>
        </>
    );
};

export default EmptyNotifications;
